import { Component, OnInit } from '@angular/core';

import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { DataService, HTTPService, HelperService, FormatService } from 'app/services';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';

@Component({
  selector: 'app-merge-customer-dialog',
  templateUrl: './merge-customer-dialog.component.html',
  styleUrls: ['./merge-customer-dialog.component.scss'],
})
export class MergeCustomerDialogComponent implements OnInit {
  isOpenSecondary: boolean = false;
  isOpenPrimary: boolean = false;
  isProcessing: boolean = false;
  customerSearchResults: any[] = [];
  secondaryCustomer: any[] = [];
  selectedSecondary: any = {};
  selectedPrimary: any = {};
  customerSearchKey: any = '';
  secondaryCustomerKey: any = '';
  isLoading = false;
  isClearIconVisible = false;
  isClearSecondaryIconVisible = false;
  primaryCustomerObj: any = {};
  secondaryCustomerObj = {};
  mergedCustomerObj = {};
  isQBOEnabled = false;
  selectCustomerTab = 'select-customer-tab';
  qboTab = 'qbo-tab';
  confirmationTab = 'confirmation-tab';
  selectedTab = 'select-customer-tab';
  isValidCompleted = false;
  isValidQBOCompleted = false;
  isMergeCustomerSelected = false;
  primaryLoader = false;
  secondaryLoader = false;
  isQboCustomerExist = false;

  constructor(
    public dConfig: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private httpService: HTTPService,
    private helperService: HelperService,
    public dataService: DataService,
    private formatService: FormatService,
    private dialogService: DialogService
  ) {}

  ngOnInit() {
    const { isQBOEnabled } = this.dConfig.data;
    this.isQBOEnabled = isQBOEnabled;
  }

  onSearchClear(event?: any, isSecondary?) {
    this.isLoading = false;
    if (isSecondary) {
      this.secondaryCustomer = [];
      this.selectedSecondary = {};
      this.secondaryCustomerKey = null;
      this.isClearSecondaryIconVisible = false;
      this.secondaryCustomerObj = {};
    } else {
      this.customerSearchResults = [];
      this.selectedPrimary = {};
      this.customerSearchKey = null;
      this.isClearIconVisible = false;
      this.primaryCustomerObj = {};
    }
    this.isMergeCustomerSelected = false;
  }

  customerSearch(query: string, isSecondary?) {
    this.isLoading = true;
    this.httpService.searchCustomer(query.trim(), { populateVehicles: true, populateContact: true, limit: 50  }).then(
      (customer: any[]) => {
        if (isSecondary) {
          if (this.selectedPrimary && this.selectedPrimary._id) {
            this.secondaryCustomer = customer.filter((customer) => customer._id !== this.selectedPrimary._id);
          } else {
            this.secondaryCustomer = customer;
          }
          if (this.secondaryCustomer.length > 0) {
            this.isLoading = false;
          }
        } else {
          if (this.selectedSecondary && this.selectedSecondary._id) {
            this.customerSearchResults = customer.filter((customer) => customer._id !== this.selectedSecondary._id);
          } else {
            this.customerSearchResults = customer;
          }
          if (this.customerSearchResults.length > 0) {
            this.isLoading = false;
          }
        }
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
        this.helperService.showToaster('error', err);
      }
    );
  }

  onSearchSelect(customer: any, isSecondary?) {
    if (!isSecondary && !this.selectedPrimary._id) {
      this.primaryLoader = true;
    } else if (isSecondary && !this.selectedSecondary._id) {
      this.secondaryLoader = true;
    }
    this.httpService.getCustomer(customer._id, { fetchVehicles: true, populateContact: true, mergeCustomer: true }).then((response) => {
      if (!isSecondary) {
        // primary customer
        this.primaryLoader = false;
        this.customerSearchResults = [response];
        this.selectedPrimary = response;
        if (response) {
          this.isClearIconVisible = true;
        }
        this.customerSearchKey = response.fullNameQBO;
        this.primaryCustomerObj = this.formatService.mergeCustomer(response);
        if (this.secondaryCustomer.length > 0) {
          this.secondaryCustomer = this.secondaryCustomer.filter((customer) => customer._id !== this.selectedPrimary._id);
        }
      } else {
        // secondary customer
        this.secondaryLoader = false;
        this.secondaryCustomer = [response];
        this.selectedSecondary = response;
        if (response) {
          this.isClearSecondaryIconVisible = true;
        }
        this.secondaryCustomerKey = response.fullNameQBO;
        this.secondaryCustomerObj = this.formatService.mergeCustomer(response);
        if (this.customerSearchResults.length > 0) {
          this.customerSearchResults = this.customerSearchResults.filter((customer) => customer._id !== this.selectedSecondary._id);
        }
      }

      // if primary and secondary customers are selected
      if (this.selectedPrimary.fullNameQBO && this.selectedSecondary.fullNameQBO) {
        //Data fetching from primary customer
        const { email, phone } = this.selectedPrimary;
        const { addLine1, addLine2 } = this.selectedPrimary.address;
        const { orders, appointments, scheduledFollowUps, marketingGroup } = this.selectedPrimary.extraDetails;
        const secondaryExtraDetails = this.selectedSecondary.extraDetails;

        //Data fetching from secondary customer
        const secondaryEmail = this.selectedSecondary.email;
        const secondaryPhone = this.selectedSecondary.phone;
        const secondaryAddress = this.selectedSecondary.address;

        this.isMergeCustomerSelected = true;
        this.mergedCustomerObj = {
          'Customer type': this.selectedPrimary.isFleetCustomer ? 'Fleet' : 'Regular',
          Name: this.selectedPrimary.fullNameQBO,
          'Phone (Primary)': phone ? this.helperService.formatPhoneNumber(phone) : this.helperService.formatPhoneNumber(secondaryPhone),
          'Email (Primary)': email ? email : secondaryEmail,
          Address: addLine1 ? addLine1 : addLine2 ? addLine2 : secondaryAddress.addLine1 ? secondaryAddress.addLine1 : secondaryAddress.addLine2,
          'No of Vehicles': this.selectedPrimary.vehicles.length + this.selectedSecondary.vehicles.length,
          'No of ROs': secondaryExtraDetails.orders + orders,
          'No of Appointment': secondaryExtraDetails.appointments + appointments,
          'No of follow-ups': secondaryExtraDetails.scheduledFollowUps + scheduledFollowUps,
          'No of marketing groups': secondaryExtraDetails.marketingGroup + marketingGroup,
        };
      }
    });
  }

  toggleSecondary() {
    this.isOpenSecondary = !this.isOpenSecondary;
  }

  togglePrimary() {
    this.isOpenPrimary = !this.isOpenPrimary;
  }

  closeDuplicateVehicleModal(data: any) {
    this.ref.close({ type: 'close' });
  }

  onBack() {
    if (this.selectedTab === this.qboTab) {
      this.selectedTab = this.selectCustomerTab;
    }
    if (this.isQBOEnabled && this.selectedTab === this.confirmationTab) {
      this.selectedTab = this.qboTab;
    }
    if (!this.isQBOEnabled && this.selectedTab === this.confirmationTab) {
      this.selectedTab = this.selectCustomerTab;
    }
  }

  onSelectTab = (tab) => {
    this.selectedTab = tab;
  };

  handleSubmit() {
    let stage = '';
    stage = this.selectedTab === this.selectCustomerTab ? 'first' : this.selectedTab === this.qboTab ? 'second' : 'third';
    if (this.isProcessing) {
      return;
    }

    // 1st stage
    if (this.selectedTab === this.selectCustomerTab && this.isValidMerge() && stage === 'first') {
      // if qbo is connected then it will go to qbo tab
      if (this.isQBOEnabled) {
        this.isQBOCustomer();
        this.selectedTab = this.qboTab;
        this.isValidCompleted = true;
      }
      // if qbo is not connected then it will go to confirmation tab
      if (!this.isQBOEnabled) {
        this.selectedTab = this.confirmationTab;
        this.isValidCompleted = true;
      }
    }

    // 2nd stage
    if (this.selectedTab === this.qboTab && stage === 'second') {
      if (this.isQBOCustomer()) {
        //  here we verify the qbo customers are merged or not
        let mergedQBOCustomer = { primaryCustomerQBOid: this.selectedPrimary.qboId, secondaryCustomerQBOid: this.selectedSecondary.qboId };
        this.httpService
          .mergeQBOCustomer(mergedQBOCustomer)
          .then((customer) => {
            if (customer && customer.merged) {
              this.selectedTab = this.confirmationTab;
              this.isValidQBOCompleted = true;
            } else {
              this.helperService.showToaster('error', 'Customers not merged on QBO');
            }
          })
          .catch((e) => this.helperService.showToaster('error', e));
      } else {
        this.isValidQBOCompleted = true;
        this.selectedTab = this.confirmationTab;
      }
    }
    // }
    // last stage
    if (this.selectedTab === this.confirmationTab && stage === 'third') {
      let mergedCustomer = { primaryCustomer: this.selectedPrimary._id, secondaryCustomer: this.selectedSecondary._id };
      this.isProcessing = true;
      this.httpService
        .mergeCustomer(mergedCustomer)
        .then((customer) => {
          if (customer) {
            this.closeDuplicateVehicleModal({});
            this.openSuccessDialog();
          }
        })
        .catch((e) => this.helperService.showToaster('error', e))
        .finally(() => {
          this.isProcessing = false;
        });
    }
  }

  openSuccessDialog() {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14 top-header-icon font-gray-35',
        styleClassMessage: 'text-center mb-4 font-gray-500 font-14',
        topHeaderIcon: 'fal fa-check',
        styleTopHeaderIcon: 'merge-customer-circle',
        styleFooter: 'footer-border',
        title: 'Customers successfully merged?',
        message: `There may be duplicate vehicles within the merged customer.
        Would you like to merge vehicles?`,
        saveBtnIcon: 'fal fa-object-ungroup mr-4p',
        customer: this.mergedCustomerObj,
        button: {
          success: { title: 'Merge vehicles' },
          cancel: { title: 'Close' },
        },
      },
    });
    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        this.helperService.openPageInSameTab(`/customer/customer-center/${this.selectedPrimary._id}?isDialogOpen`);
      }
      onClose.unsubscribe();
    });
  }

  isValidMerge = () => this.isMergeCustomerSelected;

  isQBOCustomer() {
    if (this.isQBOEnabled && this.selectedPrimary && this.selectedPrimary.qboId && this.selectedSecondary && this.selectedSecondary.qboId) {
      this.isQboCustomerExist = true;
      return true;
    } else {
      this.isQboCustomerExist = false;
      return false;
    }
  }

  //
}
